module.exports = __webpack_public_path__ + "static/media/WITH FLAP.60eef6a6.svg";